import axios, { AxiosError } from "axios";
import { getMe, logout } from "./user.service";
export const get = (url: string, opt?: any): Promise<Response> => {
    return axios.get(url, opt);
};

export const post = (url: string, data?: any, opt?: any): Promise<Response> => {
    return axios.post(url, data, opt);
};

axios.interceptors.request.use(
    (config) => {
        // Get the token from localStorage or wherever it's stored
        const me: any = getMe();
        config.headers['X-Api-Key'] = process.env.REACT_APP_API_KEY;
        if (me) {
            // Attach the token to the Authorization header
            config.headers.Authorization = `Bearer ${me.token}`;
        }

        return config;
    },
    (error: AxiosError) => {
        // Handle the error here
        return Promise.reject(error);
    }
);

// Optionally, add a response interceptor
axios.interceptors.response.use(
    (response) => {
        // Do something with the response data
        return response;
    },
    (error: AxiosError) => {
        // Handle the error here
        if (error.response && error.response.status === 401) {
            // Handle unauthorized error
            logout();
        }
        return Promise.reject(error);
    }
);